import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../services/toast/toast.service';

export function messageInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const toast = inject(ToastService);

  const handleStatusCode = (event: HttpResponse<unknown>, status: number) => {
    switch (status) {
      case 200: {
        const message = (event.body as { message?: string })?.message;
        if (typeof message === 'string') toast.success(message);
        break;
      }
    }
  };

  return next(req).pipe(
    tap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse && event.status) {
        handleStatusCode(event, event.status);
      }
    }),
  );
}
